import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class LocationHierarchyManagerService {
  environment = EnvironmentService.environment;

  constructor(private http: HttpClient) { }

  GetLocationHierarchyList(): Observable<any> {
    return this.http.get<any>(`${this.environment.LocationHierarchyManager}/locationHierarchyGetList`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetLocationHierarchyMetaDataList(): Observable<any> {
    return this.http.get<any>(`${this.environment.HierarchyManager}/locationHierarchyMetadataGetList`,)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AddUpdateLocationHierarchyList(body: any): Observable<any> {
    return this.http.post<any>(`${this.environment.LocationHierarchyManager}/locationHierarchyInsertOrUpdate`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ImportLocationHierarchyManagerList(body: any) {
    return this.http.post(`${this.environment.LocationHierarchyManager}/locationsHierarchyImport`, body)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  DeleteLocationHierarchyRow(body: any): Observable<any> {
    return this.http.post<any>(`${this.environment.LocationHierarchyManager}/locationHierarchyDelete`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }
}
